<template>
  <div>
    <!--Botones de Confirmación y Edición-->
    <div class="d-flex justify-content-end m-2">
      <!--Dropdown de edición-->
      <b-dropdown
        id="dropdown-1"
        size="sm"
        variant="info"
        text="Editar"
        right
        class="btn-elemento btn-options"
        v-show="showMenu"
        v-on:click="showAnimation = false"
        :class="{ ocultarClass: esHome }"
      >
        <b-dropdown-item
          @click="
            showAnimation == true
              ? (showAnimation = false)
              : (showAnimation = true)
          "
        >Agregar animación</b-dropdown-item>
        <b-dropdown-item
          @click="
            showMargin == true ? (showMargin = false) : (showMargin = true)
          "
        >Agregar margen</b-dropdown-item>
        <b-dropdown-item
          @click="
            showFoto == true
              ? (showFoto = false)
              : (showFoto = true)"
        >Subir foto de Ganadores</b-dropdown-item>
        <b-dropdown-item
          @click="
            showBtnGanadores == true
              ? (showBtnGanadores = false)
              : (showBtnGanadores = true),
              saveState()
          "
        >Boton de Ganadores</b-dropdown-item>
      </b-dropdown>
    </div>
    <!--NOTE menu margen-->
    <div v-show="showMargin" class="row">
      <div class="col-8 px-0 mx-0 posicionar-container">
        <div class="posicionar-titulo p-2 pl-3">
          <p class="h5">Agregar Márgenes</p>
        </div>

        <div class="p-3">
          <div class="d-flex flex-row justify-content-around">
            <div style="overflow:hidden ">
              <label for="left">Margen izquierdo</label>
              <input
                v-model.number="localMargin['ml']"
                type="number"
                min="0"
                max="8"
                name="left"
                id
              />
            </div>

            <div style="overflow:hidden ">
              <label for="top">Margen superior</label>
              <input v-model.number="localMargin['mt']" type="number" min="0" max="8" name="top" id />
            </div>
          </div>
          <div class="d-flex flex-row justify-content-around my-2">
            <div style="overflow:hidden">
              <label for="right">Margen derecho</label>
              <input
                v-model.number="localMargin['mr']"
                type="number"
                min="0"
                max="8"
                name="right"
                id
              />
            </div>
            <div style="overflow:hidden">
              <label for="bottom">Margen inferior</label>
              <input v-model.number="localMargin['mb']" type="number" min="0" max="8" name="bottom" />
            </div>
          </div>
        </div>
        <div class="col">
          <div @click="addMargin" class="btn btn-primary m-2">Aplicar</div>

          <div
            @click="
              showMargin == true ? (showMargin = false) : (showMargin = true)
            "
            class="btn btn-danger m-2"
          >Cerrar</div>
        </div>
      </div>
    </div>
    <div v-show="showFoto" class="options">
      <div class="px-0 mx-0 posicionar-container">
        <div class="posicionar-titulo p-2 pl-3">
          <p class="h5">Subir Foto</p>
          <div>
            <b-form-file
              size="sm"
              accept="image/*"
              browse-text="Abrir"
              placeholder="Imagen"
              :file-name-formatter="subirGanadores"
              class="mb-2"
            ></b-form-file>
          </div>
          <div class="d-flex justify-content-end">
            <b-button size="sm" v-on:click="showFoto = false" variant>Cerrar</b-button>
          </div>
        </div>
      </div>
    </div>
    <div v-show="showAnimation" class="options">
      <div class="px-0 mx-0 posicionar-container">
        <div class="posicionar-titulo p-2 pl-3">
          <p class="h5">Agregar animacion</p>
        </div>
        <div class="p-3">
          <div class="d-flex flex-row justify-content-around">
            <div
              @click="addAnimation('fade')"
              class="btn btn-primary py-2 px-2 animation-fade"
            >FadeIn</div>
            <div style="overflow:hidden ">
              <div
                @click="addAnimation('bounce')"
                class="btn btn-warning py-2 px-2 animation-bounce"
              >Bounce</div>
            </div>
          </div>
          <div class="d-flex flex-row justify-content-around my-2">
            <div style="overflow:hidden">
              <div
                @click="addAnimation('lr')"
                class="btn btn-primary py-2 px-2 animation-slide-l-r"
              >Slide in</div>
            </div>
            <div style="overflow:hidden">
              <div
                @click="addAnimation('rl')"
                class="btn btn-warning py-2 px-2 animation-slide-r-l"
              >Slide in</div>
            </div>
          </div>
          <div class="d-flex justify-content-end">
            <b-button size="sm" v-on:click="showAnimation = false" variant="success">Guardar</b-button>
          </div>
        </div>
      </div>
    </div>
    <!--NOTE trivia render -->
    <form ref="myformy" v-on:submit.prevent="enviarRespuesta">
      <!--Info del usuario-->
      <div v-show="showRender" :class="{ mostrarClass: esHome }">
        <div class="d-flex justify-content-center mb-5">
          <!--<label class="mr-2" for="inline-form-input-name">Nombre </label>-->
          <div class="col-8 d-flex">
            <b-input
              id="inline-form-input-name"
              class="mb-2 mr-sm-2 mb-sm-0"
              placeholder="Nombre"
              name="nombre"
              required
              v-model="nombreTrivia"
            ></b-input>
            <!--<label class="mr-2" for="inline-form-input-area">Area </label>-->
            <b-input
              id="inline-form-input-area"
              class="mb-2 mr-sm-2 mb-sm-0"
              placeholder="Area"
              name="area"
              required
              v-model="areaTrivia"
            ></b-input>
          </div>
        </div>
      </div>
      <div class="d-flex flex-wrap justify-content-center">
        <!--Preguntas-->
        <div class="m-2 col-5" v-for="(ask, index) in bloques" :key="index">
          <div class="col" v-show="showEditable" :class="{ ocultarClass: esHome }">
            <!--Bloque de pregunta-->
            <div class="pregunta element">
              <form class="m-1">
                <!--pregunta-->
                <b-form-textarea
                  :id="'textarea' + ask.id"
                  v-model="ask.pregunta"
                  placeholder="Escribe una pregunta.."
                  rows="3"
                  max-rows="6"
                ></b-form-textarea>
                <div class="row">
                  <div class="col">
                    <b-form-group>
                      <!--respuesta 1-->
                      <p class="m-2">Selecciona la respuesta correcta</p>
                      <b-input-group class="m-1">
                        <b-input-group-prepend is-text>
                          <input
                            type="radio"
                            value="1"
                            v-model="ask.correcta"
                            aria-label="Radio for following text input"
                          />
                        </b-input-group-prepend>
                        <b-form-input
                          v-model="ask.respuesta1"
                          aria-label="Text input with radio input"
                        ></b-form-input>
                      </b-input-group>
                      <!--respuesta 2-->
                      <b-input-group class="m-1">
                        <b-input-group-prepend is-text>
                          <input
                            type="radio"
                            value="2"
                            v-model="ask.correcta"
                            aria-label="Radio for following text input"
                          />
                        </b-input-group-prepend>
                        <b-form-input
                          v-model="ask.respuesta2"
                          aria-label="Text input with radio input"
                        ></b-form-input>
                      </b-input-group>
                      <!--respuesta 3-->
                      <b-input-group class="m-1">
                        <b-input-group-prepend is-text>
                          <input
                            type="radio"
                            value="3"
                            v-model="ask.correcta"
                            aria-label="Radio for following text input"
                          />
                        </b-input-group-prepend>
                        <b-form-input
                          v-model="ask.respuesta3"
                          aria-label="Text input with radio input"
                        ></b-form-input>
                      </b-input-group>
                    </b-form-group>
                  </div>
                  <div class="col">
                    <div class="input-group-sm">
                      <!--<b-form-file
                            size="sm"
                            accept="image/*"
                            browse-text="Selecciona foto"
                            placeholder="Selecciona una imagen"
                            :file-name-formatter="getName"
                        ></b-form-file>
                        <div ref="imgcontainer" class="col-12 d-flex flex-row">
                            <img ref="imgref" :src="img" class=" img-element" alt="fuuck" />
                      </div>-->
                      <b-button
                        v-show="ask.showBtn"
                        size="sm"
                        class="m-2"
                        placeholder="ignorame"
                        v-on:click="
                          ;(paro = index),
                            (ask.showImg = true),
                            (ask.showThumb = true),
                            (ask.showThumbImg = false),
                            (ask.showBtn = false)
                        "
                      >Editar Imagen</b-button>
                      <component
                        v-show="ask.showImg"
                        v-bind:is="imagen"
                        :data="data"
                        :idSection="idSection"
                        :subid="subid"
                        :elementid="elementid"
                        :online="online"
                        :isTrivia="true"
                        :idQuestion="index"
                        @setted="setImg"
                        v-on:click="paro = index"
                      ></component>
                      <b-button
                        v-show="ask.showThumb"
                        size="sm"
                        class="m-2"
                        placeholder="ignorame"
                        v-on:click="
                          ;(paro = index),
                            (ask.showImg = false),
                            (ask.showThumb = false),
                            (ask.showThumbImg = true),
                            (ask.showBtn = true)
                        "
                      >Confirmar Imagen</b-button>
                      <img v-show="ask.showThumbImg" :src="ask.src[0].url" class="py-1 w-75" />
                    </div>
                    <div class="d-flex justify-content-end m-2">
                      <b-button variant="danger" size="sm" v-on:click="deleteQuestion(index)">
                        <font-awesome-icon icon="times" />
                      </b-button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>

          <!--Fin pregunta-->

          <div v-show="showRender" class="trivia col" :class="{ mostrarClass: esHome }">
            <div class="row">
              <p class="font-weight-bold">{{ ask.pregunta }}</p>
            </div>
            <div class="row">
              <div class="col">
                <b-form-radio-group v-model="respuestas[index]">
                  <div class="row">
                    <b-form-radio
                      :value="1"
                      :name="'pregunta_' + index"
                      :id="'respuesta1-' + index"
                    ></b-form-radio>
                    <label :for="'respuesta1-' + index">
                      {{
                      ask.respuesta1
                      }}
                    </label>
                  </div>
                  <div class="row">
                    <b-form-radio
                      :value="2"
                      :name="'pregunta_' + index"
                      :id="'respuesta2-' + index"
                    ></b-form-radio>
                    <label :for="'respuesta2-' + index">
                      {{
                      ask.respuesta2
                      }}
                    </label>
                  </div>
                  <div class="row">
                    <b-form-radio
                      :value="3"
                      :name="'pregunta_' + index"
                      :id="'respuesta3-' + index"
                    ></b-form-radio>
                    <label :for="'respuesta3-' + index">
                      {{
                      ask.respuesta3
                      }}
                    </label>
                  </div>
                </b-form-radio-group>
              </div>
              <div class="col">
                <img :src="ask.src[0].url" class="py-1  w-75" alt />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-center">
        <b-button
          type="submit"
          v-show="showRender"
          class="m-2"
          size="lg"
          variant="secondary"
          :class="{ mostrarClass: esHome }"
        >{{ mensaje.text }}</b-button>
      </div>
    </form>

    <div class="d-flex justify-content-center" :class="{ ocultarClass: esHome }">
      <b-button
        v-show="showEditable"
        class="m-2"
        size="sm"
        v-on:click="agregarPregunta"
        variant="success"
        :class="{ ocultarClass: esHome }"
      >Agregar Pregunta</b-button>
      <b-button
        v-show="showEditable"
        class="m-2"
        size="sm"
        v-on:click="add"
        variant="success"
        :class="{ ocultarClass: esHome }"
      >Finalizar Edición</b-button>
      <b-button
        v-show="showRender"
        class="m-2"
        size="sm"
        v-on:click="reset"
        variant="success"
      >Editar Trivia</b-button>
      <!--<b-button
        v-show="showRender"
        class="m-2"
        size="sm"
        v-on:click="generarPHP"
        variant="danger"
        >Generar PHP</b-button
      >-->
    </div>
    <div class="d-flex justify-content-center">
      <b-button
        v-show="showBtnGanadores"
        class="m-2"
        size="lg"
        v-on:click="showModalImg = true"
        variant="primary"
      >Ganadores de la Trivia anterior</b-button>
    </div>
    <!--Modal -->
    <div id="modalimg" class="modalthis" v-show="showModalImg" v-on:click="showModalImg = false">
      <div class="modal-content-imagen">
        <div v-if="online">
          <img :key="ganadoresimg" class="py-1" :style="'width: 90%;'" :src="ganadoresimg" />
        </div>
        <div v-else>
          <div v-if="mes === '07'">
            <img src="imgs/ganadores_julio.jpg" class="py-1" :style="'width: 90%;'" />
          </div>
          <div v-else-if="mes === '08'">
            <img src="imgs/ganadores_agosto.jpg" class="py-1" :style="'width: 90%;'" />
          </div>
          <div v-else>
            <img :src="ganadoresimg" class="py-1" :style="'width: 90%;'" />
          </div>
        </div>
        <span v-on:click="showModalImg = false" class="close">&times;</span>
      </div>
    </div>
  </div>
</template> 
<script>
import Imagen from '@/components/atomos/Imagen.vue'
import { saveAs } from 'file-saver'
import axios from 'axios'
import firebase from 'firebase'
export default {
  name: 'Trivia',
  components: { Imagen },
  props: {
    index: String,
    data: Object,
    subid: Number,
    idSection: String,
    esHome: Boolean,
    elementid: Number,
    online: Boolean
  },
  data() {
    return {
      img: 'Imagen',
      k: 3,
      stringPHP:
        '<?php require_once "conexion.php"; \n if ($conn->connect_error) { die("Error en la conexión: " . $conn->connect_error); } else{ echo "Conexion succesful"; \n',
      paro: 0,
      imagen: 'Imagen',
      showMenu: true,
      showFoto: false,
      showBtnGanadores: false,
      showAnimation: false,
      showMargin: false,
      showEditable: true,
      showModalImg: false,
      showRender: false,
      animation: '',
      bloques: [],
      mes: 'none',
      urls: [
        {
          url: 'hehe',
          id: 0
        }
      ],
      respuestas: [],
      correctas: [],
      mensaje: {
        text: 'Enviar Respuesas',
        value: 0
      },
      nombreTrivia: '',
      areaTrivia: '',
      ganadoresimg: '',
      localMargin: {
        mt: 0,
        mr: 0,
        mb: 0,
        ml: 0
      },
      localPadding: {
        pt: 0,
        pr: 0,
        pb: 0,
        pl: 0
      }
    }
  },
  created() {
    this.mes = window.localStorage.getItem('revistaNum')

    this.localRoot = JSON.parse(window.localStorage.getItem('root'))
    if (this.online) {
      this.ganadoresimg = this.localRoot['detalles'][0]['img_ganadores'][0][
        'url'
      ]
    } else {
      this.ganadoresimg =
        'imgs/' + this.localRoot['detalles'][0]['img_ganadores'][0]['name']
    }
    console.log('img', this.ganadoresimg)

    this.bloques = this.localRoot['componentes']['secciones'][this.idSection][
      'subsecciones'
    ][this.subid]['elements'][this.elementid].extras
    //this.$delete(this.bloques, 0)
    //this.$delete(this.bloques, 0)
    //console.log(this.bloques)
    this.animation = this.localRoot['componentes']['secciones'][this.idSection][
      'subsecciones'
    ][this.subid].animation
    this.localMargin = this.localRoot['componentes']['secciones'][
      this.idSection
    ]['subsecciones'][this.subid]['elements'][this.elementid]['margin']
    this.localPadding = this.localRoot['componentes']['secciones'][
      this.idSection
    ]['subsecciones'][this.subid]['elements'][this.elementid]['padding']
    this.showBtnGanadores = this.localRoot['componentes']['secciones'][
      this.idSection
    ]['subsecciones'][this.subid]['elements'][
      this.elementid
    ].gallery_settings[0]['stateBtn']
    //console.log(this.animation)
    for (let index = 0; index < this.bloques.length; index++) {
      this.respuestas.push(0)
    }

    this.bloques.forEach(element => {
      this.correctas.push(parseInt(element.correcta))
    })

   
    if(this.online){
        this.ganadoresimg = this.localRoot['detalles'][0]['img_ganadores'][0]['url']
    } else {
        this.ganadoresimg = 'imgs/'+this.localRoot['detalles'][0]['img_ganadores'][0]['name']
    }
    console.log('img', this.ganadoresimg)
  },
  mounted() {
    this.addAnimation(this.animation)
    this.addMargin()
  },
  methods: {
    addMargin() {
      this.localRoot = JSON.parse(window.localStorage.getItem('root'))
      let textElementMargin = this.$refs.myformy
      if (textElementMargin === undefined) return

      textElementMargin.className = ''

      textElementMargin.classList.add(
        'pt-' + this.localPadding['pt'],
        'mt-' + this.localMargin['mt']
      )
      textElementMargin.classList.add(
        'pr-' + this.localPadding['pr'],
        'mr-' + this.localMargin['mr']
      )
      textElementMargin.classList.add(
        'pb-' + this.localPadding['pb'],
        'mb-' + this.localMargin['mb']
      )
      textElementMargin.classList.add(
        'pl-' + this.localPadding['pl'],
        'ml-' + this.localMargin['ml']
      )

      this.localRoot['componentes']['secciones'][this.idSection][
        'subsecciones'
      ][this.subid]['elements'][this.elementid]['margin'] = this.localMargin

      this.localRoot['componentes']['secciones'][this.idSection][
        'subsecciones'
      ][this.subid]['elements'][this.elementid]['padding'] = this.localPadding

      window.localStorage.setItem('root', JSON.stringify(this.localRoot))
    },

    enviarRespuesta() {
      // console.log(this.bloques)
      // console.log(this.respuestas)
      var arraysMatch = function(arr1, arr2) {
        // Check if the arrays are the same length
        if (arr1.length !== arr2.length) return false

        // Check if all items exist and are in the same order
        for (var i = 0; i < arr1.length; i++) {
          if (arr1[i] !== arr2[i]) return false
        }

        // Otherwise, return true
        return true
      }

      let sonIguales = arraysMatch(this.correctas, this.respuestas)

      if (sonIguales) {
        axios
          .post('inserta_ganador.php', {
            nombre: this.nombreTrivia,
            area: this.areaTrivia
          })
          .then(resp => {
            console.log(resp.data)
            if (resp.data) {
              this.mensaje.text = 'Gracias por partipar!'
            } else {
              this.mensaje.text =
                'Ocurripo un error, envía de nuevo tus respuestas.'
            }
          })
          .catch(Error => {
            console.log(Error)
          })
      } else {
        this.mensaje.text = 'Gracias por participar!'
        return
      }
    },

    hey() {
      this.$refs.foo.addThing()
    },

    savePregunta(param) {
      this.correcta = param
    },
    //cuando se agrega una nueva pregunta algo truena con la img, dice undefinided url
    agregarPregunta() {
      this.localRoot = JSON.parse(window.localStorage.getItem('root'))
      this.bloques = this.localRoot['componentes']['secciones'][this.idSection][
        'subsecciones'
      ][this.subid]['elements'][this.elementid].extras
      console.log("bloques", this.bloques)
      console.log("extras", this.localRoot['componentes']['secciones'][this.idSection][
        'subsecciones'
      ][this.subid]['elements'][this.elementid].extras)
      this.bloques.push({
        pregunta: 'default',
        respuesta1: 'respuesta1',
        respuesta2: 'respuesta2',
        respuesta3: 'respuesta3',
        correcta: '1',
        src: [{ name: 'muestra2.jpg', url: 'laurl' }],
        showImg: false,
        showThumb: false,
        showBtn: true,
        showThumbImg: true
      })
      this.localRoot['componentes']['secciones'][this.idSection][
        'subsecciones'
      ][this.subid]['elements'][this.elementid].extras = this.bloques
      let parsedRoot = JSON.stringify(this.localRoot)
      window.localStorage.setItem('root', parsedRoot)
    },
    getName(file) {
      if (file.length === 1) {
        let reader = new FileReader()
        reader.onload = () => {
          let dataURL = reader.result
          this.img = dataURL
          let item = this.$refs.imgref
          //const urlObj = URL.createObjectURL(file[0])

          item.src = dataURL
          console.log('aakiii trivia')
        }
        reader.readAsDataURL(file[0])
      } else {
        return alert('Error')
      }
    },
    setImg(value) {
      console.log('entre??')
      this.bloques[this.paro]['src'][0]['url'] = value
    },
    reset() {
      let i = 0
      this.showEditable = true
      this.showRender = false
      console.log(this.bloques.length)
      for (i = 0; i < this.bloques.length; i++) {
        this.bloques[i].showImg = false
        console.log(i)
      }
    },
    add() {
      this.localRoot.componentes.secciones[this.idSection].subsecciones[
        this.subid
      ]['elements'][this.elementid]['extras'] = this.bloques
      let parsedRoot = JSON.stringify(this.localRoot)
      window.localStorage.setItem('root', parsedRoot)
      this.showRender = true
      this.showEditable = false
    },
    deleteTrivia() {
      this.$nextTick(() => {
        this.localRoot = JSON.parse(window.localStorage.getItem('root'))
        this.localRoot['detalles'][0]['hayTrivia'] = false
        this.localRoot['componentes']['secciones'][this.idSection][
          'subsecciones'
        ][this.subid]['elements'][this.elementid]['type'] = 'Texto'
        this.localRoot['componentes']['secciones'][this.idSection][
          'subsecciones'
        ][this.subid]['elements'][this.elementid].extras = []
        this.localRoot['componentes']['secciones'][this.idSection][
          'subsecciones'
        ][this.subid]['elements'][this.elementid]['src'] =
          '<p>Inserta un elemento</p>'
        let parsedRoot = JSON.stringify(this.localRoot)
        window.localStorage.setItem('root', parsedRoot)
      })
    },
    addAnimation(type) {
      this.localRoot = JSON.parse(window.localStorage.getItem('root'))
      switch (type) {
        case 'rl':
          /*this.$refs.popsref.classList.remove('animation-slide-l-r')
              this.$refs.imgref.classList.remove('animation-bounce')
              this.$refs.imgref.classList.remove('animation-fade')
              this.$refs.imgref.classList.add('animation-slide-r-l')*/
          this.animation = 'rl'
          break

        case 'lr':
          /*this.$refs.imgref.classList.remove('animation-slide-r-l')
              this.$refs.imgref.classList.remove('animation-bounce')
              this.$refs.imgref.classList.remove('animation-fade')
              this.$refs.imgref.classList.add('animation-slide-l-r')*/
          this.animation = 'lr'
          break
        case 'bounce':
          /*this.$refs.imgref.classList.remove('animation-slide-l-r')
              this.$refs.imgref.classList.remove('animation-slide-r-l')
              this.$refs.imgref.classList.remove('animation-fade')
              this.$refs.imgref.classList.add('animation-bounce')*/
          this.animation = 'bounce'
          break
        case 'fade':
          this.animation = 'fade'
          break

        default:
          break
      }
      this.localRoot['componentes']['secciones'][this.idSection][
        'subsecciones'
      ][this.subid]['elements'][this.elementid]['animation'] = this.animation
      let parsedRoot = JSON.stringify(this.localRoot)
      window.localStorage.setItem('root', parsedRoot)
    },
    saveState() {
      //this.url = this.localRoot['componentes']['secciones'][this.idSection]['subsecciones'][this.subid]['elements'][this.elementid].src
      //this.modalSize = this.localRoot['componentes']['secciones'][this.idSection]['subsecciones'][this.subid]['elements'][this.elementid].gallery_settings[0]['opM']
      //this.colorbg = this.localRoot['componentes']['secciones'][this.idSection]['subsecciones'][this.subid]['elements'][this.elementid].gallery_settings[0]['bgcolorM'] = this.colorbg
      //this.opbg = this.localRoot['componentes']['secciones'][this.idSection]['subsecciones'][this.subid]['elements'][this.elementid].gallery_settings[0]['opM']
      this.localRoot = JSON.parse(window.localStorage.getItem('root'))
      this.localRoot['componentes']['secciones'][this.idSection][
        'subsecciones'
      ][this.subid]['elements'][this.elementid].gallery_settings[0][
        'stateBtn'
      ] = this.showBtnGanadores
      let parsedRoot = JSON.stringify(this.localRoot)
      window.localStorage.setItem('root', parsedRoot)
    },

    subirGanadores(file) {
      if (file.length === 1) {
        let locationStorage = '/imagenes/'
        let storageRef = firebase.storage().ref(locationStorage + file[0].name)
        let uploadTask = storageRef.put(file[0])

        uploadTask.on(
          'state_changed',
          snapshot => {
            switch (snapshot.state) {
              case firebase.storage.TaskState.PAUSED:
                console.log('Upload is paused')
                break
              case firebase.storage.TaskState.RUNNING:
                console.log('Upload is running')
                break
            }
          },
          error => {
            console.log(error)
          },
          () => {
            uploadTask.snapshot.ref.getDownloadURL().then(downloadURL => {
              this.firebaseURL2 = downloadURL
              this.localRoot = JSON.parse(window.localStorage.getItem('root'))
              console.log(this.firebaseURL2)
              console.log(file[0].name)
              this.localRoot['detalles'][0]['img_ganadores'][0][
                'url'
              ] = this.firebaseURL2
              this.localRoot['detalles'][0]['img_ganadores'][0]['name'] =
                file[0].name
              let parsedRoot = JSON.stringify(this.localRoot)
              window.localStorage.setItem('root', parsedRoot)
              if (this.online) {
                this.ganadoresimg = this.firebaseURL2
              } else {
                this.ganadoresimg = file[0].name
              }

              alert('La imagen se ha subido!')
            })
          }
        )

        // var fileName = file.target.files[0].name;
        // alert(file[0].name)

        // this.img = 'imgs/' + file[0].name
        // let reader = new FileReader()
        // reader.onload = () => {

        //   let dataURL = reader.result
        //   this.img = dataURL
        //   this.$emit('setted', this.img)
        //   // this.url = dataURL
        // }
        // reader.readAsDataURL(file[0])
      } else {
        return alert('Solo se puede subir una imagen')
      }
    },

    generarPHP() {
      var sql = '$sql = '
      sql += '$respuestas = [];\n$solucion = ['
      var temp = ''
      this.bloques.forEach((question, index) => {
        temp +=
          '$pregunta_' +
          index +
          '= $_POST["pregunta_' +
          index +
          '"];\n array_push($respuestas, $pregunta_' +
          index +
          ' );\n'
        if (index == this.bloques.length - 1) {
          sql += question.correcta
        } else sql += question.correcta + ','
      })

      sql += '];\n $nombre = $_POST["nombre"]; \n $area = $_POST["area"];\n'
      sql += temp
      sql +=
        '$iguales = $respuestas === $solucion; \n' +
        'if($iguales == 1){ \n' +
        'if ($conn->connect_error) { \n' +
        'die("Error en la conexión: " . $conn->connect_error);\n' +
        '}else{\n' +
        'echo "Éxito en la conexión iguales = 1";\n' +
        '$ganador = 1;\n' +
        '$sql = "INSERT INTO tabla_respuestas (CAMPO_NOMBRE, CAMPO_AREA, CAMPO_GANADOR)\n' +
        'VALUES ("$nombre", "$area", "$ganador")";\n' +
        'if (mysqli_query($conn, $sql)) {\n' +
        'echo "Insercion exitosa.";\n' +
        '}else{\n' +
        'echo "Error: " . $sql . "<br>" . mysql_error($conn);\n' +
        '}\n' +
        'mysql_close($conn);\n' +
        '}\n' +
        '}else if($iguales != 1) {\n' +
        'if ($conn->connect_error) {\n' +
        'die("Error en la conexión: " . $conn->connect_error);\n' +
        '}else{\n' +
        'echo "Éxito en la conexión iguales distinto a 1";\n' +
        '$ganador = 0;\n' +
        '$sql = "INSERT INTO tabla_respuestas (CAMPO_NOMBRE, CAMPO_AREA, CAMPO_GANADOR)\n' +
        'VALUES ("$nombre", "$area", "$ganador")";\n' +
        'if (mysqli_query($conn, $sql)) {\n' +
        'echo "Insercion exitosa.";\n' +
        '}else{\n' +
        'echo "Error: " . $sql . "<br>" . mysql_error($conn);\n' +
        '}\n' +
        'mysqli_close($conn);\n }}?>'
      var finalPHP = this.stringPHP + sql
      var blob = new Blob([finalPHP], { type: 'text/plain;charset=utf-8' })
      saveAs(blob, 'inserta_respuestas.php')
    },
    deleteQuestion(index) {
      this.localRoot = JSON.parse(window.localStorage.getItem('root'))
      this.$delete(this.bloques, index)
      this.localRoot['componentes']['secciones'][this.idSection][
        'subsecciones'
      ][this.subid]['elements'][this.elementid].extras = this.bloques
      let parsedRoot = JSON.stringify(this.localRoot)
      window.localStorage.setItem('root', parsedRoot)
    }
  }
}
</script>

<style type="scss" scoped>
.trivia .row {
  min-height: auto !important;
}

.modalthis {
  position: fixed;
  z-index: 1000;
  left: 0;
  top: 0;
  text-align: center;
  width: 100%;
  height: 100%;
  overflow: auto;
}

/* Modal Content (Image) */
.modal-content-imagen {
  margin: 100px auto;
  display: inline-block;
  width: 90%;
  text-align: center;
  font-size: 30px;
  position: relative;
  animation-name: zoom;
  animation-duration: 0.6s;
}

@keyframes zoom {
  from {
    transform: scale(0);
  }
  to {
    transform: scale(1);
  }
}

/*Cerrar Modal */
.close {
  position: absolute;
  top: -10px;
  right: -10px;
  color: #000;
  font-size: 50px;
  line-height: 20px;
  font-weight: bold;
  transition: 0.3s;
}

.close:hover,
.close:focus {
  color: #000;
  text-decoration: none;
  cursor: pointer;
}
</style>
